export default "__VITE_ASSET__BoQJpq0S__"